import React from 'react';
import Slider from 'react-slick/lib/slider';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from 'axios';
import HeroNavbar from '../Navbar/Navbar';
import './Herocarousel.css'
import Loader from '../Loader/Loader';

const HeroCarousel = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000
    };
    const [img, setImg] = React.useState([]);

    React.useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_LINK}carousel`).then(res => {
            setImg(res.data);
        });
    }, []);
    return (
        <>
            <HeroNavbar></HeroNavbar>
            {
                img.length === 0 ?
                    <div className='pb-5 px-0 mx-0 overflow-hidden' style={{ position: '', backgroundColor: '#737373c4', width: '100vw', height: '100vh', marginBottom: '55px' }}></div> :
                    <Slider {...settings} className=' pb-5 px-0 mx-0 overflow-hidden'>
                        {img.map(carImg => (
                            <div key={carImg} style={{ position: 'absolute' }}>
                                <div>
                                    <img className='carsImg' src={`data:image/png;base64,${carImg.image}`} alt="" />
                                </div>
                            </div>
                        ))}
                    </Slider>
            }

            <div className='carText' >
                <div >
                    <div className='mx-3 hero-title'>
                        <p className='cth'>A trillion $ ​opportunity <br /> Keep Co2 out of Air</p>
                    </div>
                    <div className='d-flex flex-wrap ms-2  playstore'>
                        <button style={{ border: 'none', backgroundColor: 'transparent' }} className=''><img src="/img/playstore.png" alt="" /></button>
                        <button style={{ border: 'none', backgroundColor: 'transparent' }} className=' mt-md-0'><img src="/img/appstore.png" alt="" /></button>
                    </div>
                    <div className='mx-3'>
                        <p className='text-white joinText'>Join our community</p>
                    </div>
                    <div className='ms-1'>
                        <div className="wrapper">
                            <div className="icon facebook">
                                <span><i className="fab fa-facebook-f"></i></span>
                            </div>
                            <div className="icon twitter">
                                <span><i className="fab fa-twitter"></i></span>
                            </div>
                            <div className="icon instagram">
                                <span><i className="fab fa-instagram"></i></span>
                            </div>
                            <div className="icon github">
                                <span><i className="fab fa-github"></i></span>
                            </div>
                            <div className="icon youtube">
                                <span><i className="fab fa-youtube"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default HeroCarousel;